import { MOYENS_PAIEMENT_LOCAUX, type MoyenPaiementLocal } from "@donoor/utils";

type CleTitulaire = "nomTitulaire" | "nomRequis" | "nomEnHaut";

/**
 * Clé de texte du nom demandé par un moyen local : « titulaire de la carte »
 * (Bancontact) ou « titulaire du compte » (iDEAL | Wero, qui passe par le
 * compte bancaire) — 01/11/2026.
 */
export function cleTexteTitulaire(cle: CleTitulaire, moyen: MoyenPaiementLocal): string {
  return `don.moyensLocaux.${cle}${MOYENS_PAIEMENT_LOCAUX[moyen].titulaire === "compte" ? "Compte" : ""}`;
}
